function initialize() {
  // Exibir mapa;
  var myLatlng = new google.maps.LatLng(-21.764163, -43.349307);
  var mapOptions = {
    zoom: 16,
    center: {lat:  -21.76448192362656, lng:  -43.34912627036134},
    scrollwheel: false,
    //panControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    backgroundColor: "#d58400",
    disableDefaultUI: false
  }

  // Exibir o mapa na div #mapa;
  var map = new google.maps.Map(document.getElementById("mapa"), mapOptions);
    
    // Marcador personalizado;
      var image = window.asset + '/images/site/map-marker.svg';
      var marcadorPersonalizado = new google.maps.Marker({
          position: myLatlng,
          map: map,
          icon: image,
          title: 'Marco Zero - Curso Nota 10',
          animation: google.maps.Animation.DROP,
      });
    
    // Parâmetros do texto que será exibido no clique;
    var contentString = "<div id='info-maps'><h2><a href='http://emiolo-homolog.cloudapp.net/curso_nota_10/fale-conosco'>Entre em Contato</a></h2><ul class='contacts list-unstyled'><li><span aria-hidden='true' class='glyphicon glyphicon-search'></span><span>(32) 3026-2744</span></li><li><span aria-hidden='true' class='glyphicon'>@</span><span>atendimentocursonota10@gmail.com</span></li><li><span aria-hidden='true' class='glyphicon glyphicon-map-marker'></span><span>Av. Presidente Itamar Franco, 1418 - Centro, Juiz de Fora - MG</span></li></ul></div>";

    var infowindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 700
    });
    google.maps.event.addListener(marcadorPersonalizado, 'click', function() {
        infowindow.open(map,marcadorPersonalizado);
    });
    infowindow.open(map,marcadorPersonalizado);
    
    google.maps.event.addListener(map, 'center_changed', function() {
        var newCenter = map.getCenter();
//        console.log(newCenter.lat());
//        console.log(newCenter.lng());
    });
    
    
    google.maps.event.addListener(infowindow, 'domready', function() {

       // Referência ao DIV que recebe o conteúdo da infowindow recorrendo ao jQuery
       var iwOuter = $('.gm-style-iw');

       /* Uma vez que o div pretendido está numa posição anterior ao div .gm-style-iw.
        * Recorremos ao jQuery e criamos uma variável iwBackground,
        * e aproveitamos a referência já existente do .gm-style-iw para obter o div anterior com .prev().
        */
       var iwBackground = iwOuter.prev();

       // Remover o div da sombra do fundo
       iwBackground.children(':nth-child(2)').css({'display' : 'none'});

       // Remover o div de fundo branco
       iwBackground.children(':nth-child(4)').css({'display' : 'none'});

        iwOuter.parent().parent().css({
            left: '210px',
            top: '150px'
        });
        
        iwBackground.css('display','none');
        
        // Altera a cor desejada para o contorno da cauda.
        // O contorno da cauda é composto por dois descendentes do div que contem a cauda.
        // O método .find('div').children() faz referência a todos os div que sejam os descendentes directos do div anterior
        iwBackground.children(':nth-child(3)').find('div').children().css({
            'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px',
            'z-index' : '1',
            transform: 'skewX(30deg)'});
        /*

        iwBackground.parent().parent().parent().parent().children("div:first, div:nth-child(4)").css({
          left: "137px",
          top: "-61px"
        });
        
        */

    });
}



// Função para carregamento assíncrono
function loadScript() {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "http://maps.googleapis.com/maps/api/js?key=AIzaSyB6Rlqacjm5j1VJ0gLzhofZSlOFnaJ1tnw&callback=initialize";
  document.body.appendChild(script);
}

window.onload = loadScript;
